import React, { useEffect, useRef, useState, useMemo } from "react";

export default function useAddressBeyan({
  innerTexts,
  ImageUploadFormData,
  loading,
}) {
  const [pendingFile, setPendingFile] = useState(null);
  const [pendingExt, setPendingExt] = useState("");
  const [uploaded, setUploaded] = useState(false);
  const [previewName, setPreviewName] = useState("");
  // bunu preview icin kullanabiliriz ileride
  const [previewSrc, setPreviewSrc] = useState("");
  const [checked, setChecked] = useState(false);

  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  const beyanRequired = !!innerTexts?.addressBeyan;
  const beyanActive = beyanRequired && innerTexts?.addresVerify;

  const isDisabled = useMemo(() => {
    return beyanActive && (!uploaded || !checked);
  }, [beyanActive, uploaded, checked]);

  const onPickFile = () => fileInputRef.current?.click();
  const onTakePhoto = () => cameraInputRef.current?.click();
  const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);
  const onPickDocument = () => {
    if (isMobileDevice()) {
      onTakePhoto();
      return;
    }
    onPickFile();
  };

  const onFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const allowed = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "application/pdf",
    ];
    if (!allowed.includes(file.type)) {
      alert("Dosya formatı JPG, JPEG, PNG, GIF veya PDF olmalıdır.");
      return;
    }

    setPreviewName(file.name);
    setUploaded(false);
    setPendingFile(file);

    const typeMap = {
      "image/jpeg": ".jpg",
      "image/jpg": ".jpg",
      "image/png": ".png",
      "image/gif": ".gif",
      "application/pdf": ".pdf",
    };
    const ext = (typeMap[file.type] || "unknown").replace(".", "");
    setPendingExt(ext);

    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => {
      if (file.type === "application/pdf") {
        setPreviewSrc("/images/nullpdf.jpg");
      } else {
        setPreviewSrc(`data:${file.type};base64,${window.btoa(reader.result)}`);
      }
    };
  };

  useEffect(() => {
    if (!beyanActive) return;
    if (!checked || !pendingFile || uploaded) return;

    ImageUploadFormData(
      "islem=image_upload",
      pendingFile,
      {
        queryParams: { step: 3 },
        additionalData: {
          image_column: "ADRES_TEYIT",
          dosya_uzantisi: pendingExt || "pdf",
          adres_teyit_beyani: "1",
        },
      },
      null
    );
    setUploaded(true);
  }, [
    beyanActive,
    checked,
    pendingFile,
    pendingExt,
    uploaded,
    ImageUploadFormData,
  ]);

  const renderView = () => {
    if (!beyanActive) return null;

    return (
      <div className="row" style={{ marginTop: 10 }}>
        <div className="col-md-12" style={{ marginTop: "10px", padding: "0 30px" }}>
          <div className="card">
            <div className="card-body">
              <h5 style={{ fontWeight: 700, marginBottom: 10 }}>
                Adres (İkametgâh) Belgesi
              </h5>

              {previewName ? (
                <div style={{ marginBottom: 10 }}>
                  <p
                    style={{
                      marginBottom: 4,
                      color: "#046d88",
                      fontWeight: 600,
                    }}
                  >
                    {previewName}
                  </p>
                </div>
              ) : null}

              {loading ? (
                <button className="btn btn-primary btn-block" disabled>
                  Bir belge yükleniyor. Bekleyiniz...
                </button>
              ) : (
                <button
                  onClick={onPickDocument}
                  className="btn btn-primary btn-block"
                >
                  {isMobileDevice() ? "Fotoğraf Çek" : "Belge Yükle (PDF, JPG, PNG, GIF)"}
                </button>
              )}

              <input
                type="file"
                accept="image/*"
                capture="environment"
                ref={cameraInputRef}
                onChange={onFileChange}
                style={{ display: "none" }}
              />
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.gif"
                ref={fileInputRef}
                onChange={onFileChange}
                style={{ display: "none" }}
              />

              <div className="form-check" style={{ marginTop: 12 }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="addressBeyanCheckbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <label
                  style={{ marginLeft: "1rem" }}
                  className="form-check-label"
                  htmlFor="addressBeyanCheckbox"
                >
                  Yüklediğim adres belgesini onaylıyor ve bu adreste ikamet ettiğimi beyan ediyorum.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return {
    renderView,
    isDisabled,
  };
}
